<lib-modal-layout  [title]="'Loss Runs Request'" [subtitle]="data.businessName + ' - ' + data.policyNumber" >
   <div  class="text-center my-4">
   <div class="my-4">Loss Run {{data.status}}</div>
   <div class="my-4">Policy Term {{data.policyTerm}}</div>
   <div class="my-8">{{data.notes}}</div>
   <lib-button *ngIf="data.status === 'Issued'" [type]="'submit'" [text]="'Download File'" 
                [icon]="'rightarrow'" (click)="download(data.guid)"></lib-button>
                </div>
                
</lib-modal-layout>